import { ArticleModel } from '@/typings';
import { ref } from 'vue';
import { doSendCounterView } from '@/services';

export function useExpand (article:ArticleModel) {
    const is_expanded = ref(false);
    const is_ever_expanded = ref(false);
    const counter_view = ref(article.counter_view);

    const expand = () => {
        is_expanded.value = !is_expanded.value;
        if (!is_ever_expanded.value) {
            doSendCounterView(article).then((json) => {
                counter_view.value = json.data.counter_view;
            });

            is_ever_expanded.value = true;
        }
    };
    return {
        is_expanded,
        counter_view,
        expand
    };
}
